/**
 * Navigate helpers kept in a separate module so tests can mock them. In our
 * jsdom test environment, `window.location.assign` / `replace` are read-only
 * and cannot be spied on directly.
 */

/** Replace so Back does not return to the success hop. */
export function replaceLocation(url: string): void {
  window.location.replace(url);
}

export function assignLocation(url: string): void {
  window.location.assign(url);
}
